import { createInterceptorCondition, IncludeBearerTokenCondition } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// O token só é enviado para a API do SGE, nunca para serviços de terceiros.
export const bearerTokenConditions: IncludeBearerTokenCondition[] = environment.api.sendBearerToken
  ? [createInterceptorCondition<IncludeBearerTokenCondition>({
      urlPattern: new RegExp(`^${escapeRegExp(environment.api.baseUrl)}(/.*)?$`, 'i')
    })]
  : [];
